<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card" style="border-radius: 12px">
          <ul
            class="nav nav-pills"
            id="pills-tab"
            role="tablist"
            style="border-radius: 12px; flex-wrap: wrap"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.name === 'BeesResumen' ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/bees')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-chart-simple text-success"
                ></i>
                Resumen
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.name === 'BeesLeads' ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/bees/leads')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-address-book text-success"
                ></i>
                Leads
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.name === 'BeesSales' ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/bees/sales')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-shopping-cart text-success"
                ></i>
                Ventas
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link2"
                :class="$route.name === 'BeesBot' ? 'active' : ''"
                type="button"
                role="tab"
                @click="$router.push('/bees/bot')"
              >
                <i
                  style="font-size: 14px; margin-right: 5px"
                  class="fa fa-robot text-success"
                ></i>
                Bot
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
        style="margin-top: 15px"
      >
        <router-view
          :user-id="userId"
          :token-auth="tokenAuth"
          :role="role"
          :user-role="userRole"
        />
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import "bootstrap"; //no eliminar, este le da el evento al nav pills

export default {
  data() {
    let datos = this.$store.state.user;

    return {
      isMobile: this.$isMobile,
      userId: datos.userId,
      tokenAuth: this.$store.state.tokenAuth,
      role: datos.role,
      userRole: this.$store.state.userRole || "",
    };
  },
  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("inactiveShowMenu");
    }
  },
  mounted() {
    document.title = "XTRIMPRO - BEES";
    if (this.$store.state.userRole) {
      this.userRole = this.$store.state.userRole;
    } else {
      this.getAccess();
    }
  },
  methods: {
    getAccess() {
      this.$https
        .post("/auth/accessAdminPanel")
        .then((response) => {
          this.userRole = response.data.role;
          this.$store.commit("SET_USER_ROLE", response.data.role);
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    },
  },
};
</script>
